"use strict"

import {observable, action} from "mobx"

import {load} from "recaptcha-v3"
import config from "../../global/config/settings"
import api from "../../global/actions/api"

import GlobalStore from "../../global/store/GlobalStore"
import moment from "moment"

class RequestStore {
	@observable data = []
	@observable filterDevices = []
	@observable recordRounds = []

	regionType = [
		{
			_id: "mrr",
			code: "mrr",
			code_ext: "MRR",
			description: "",
			item_order: null,
			name_ext: "Menej rozvinutý región",
			parent_code: "",
			search_column: "mrr menej rozvinuty region"
		},
		{
			_id: "vrr",
			code: "vrr",
			code_ext: "VRR",
			description: "",
			item_order: null,
			name_ext: "Viac rozvinutý región",
			parent_code: "",
			search_column: "vrr viac rozvinuty region"
		}
	]

	requestStatus = [
		{
			_id: "sent",
			code: "sent",
			code_ext: "plat",
			description: "Prijatá – stav žiadosti po odoslaní",
			item_order: 2,
			name_ext: "Prijatá",
			parent_code: "",
			search_column: "plat prijata"
		},
		{
			_id: "paid",
			code: "paid",
			code_ext: "uhr",
			description: "Uhradená",
			item_order: 5,
			name_ext: "Uhradená",
			parent_code: "",
			search_column: "uhr uhradena"
		},
		{
			_id: "withdrawn",
			code: "withdrawn",
			code_ext: "spatvz",
			description: "Späťvzatá",
			item_order: 3,
			name_ext: "Späťvzatá",
			parent_code: "",
			search_column: "spatvz spatvzata"
		},
		{
			_id: "reject",
			code: "reject",
			code_ext: "zam",
			description: "Zamietnutá",
			item_order: 4,
			name_ext: "Zamietnutá",
			parent_code: "",
			search_column: "zam zamietnuta"
		},
		{
			_id: "contracted",
			code: "contracted",
			code_ext: "zazmluv",
			description: "Zazmluvnená",
			item_order: 7,
			name_ext: "Zazmluvnená",
			parent_code: "",
			search_column: "zazmluv zazmluvnena"
		},
		{
			_id: "instack",
			code: "instack",
			code_ext: "vzasob",
			description: "V zásobníku",
			item_order: 6,
			name_ext: "V zásobníku",
			parent_code: "",
			search_column: "vzasob v zasobniku"
		},
		{
			_id: "stopped",
			code: "stopped",
			code_ext: "zastav",
			description: "Zastavené konanie",
			item_order: 8,
			name_ext: "Zastavené konanie",
			parent_code: "",
			search_column: "zastav zastavene konanie"
		}
	]

	@action getWaitingList(form) {
		GlobalStore.loading(true, "Načítam...")

		try {
			load(config.SITE_KEY).then((recaptcha) => {
				recaptcha.execute("records_order").then((recaptchaToken) => {
					const values = form.values()
					logger(".....form.values.....", values)

					let req = {
						filters: []
					}

					if (isNotEmpty(values.request_number)) {
						req.filters.push({
							associated_column: "request_number",
							predicate: "=",
							values: [
								{
									id_value: values.request_number
								}
							]
						})
					}

					if (isNotEmpty(values.request_state)) {
						req.filters.push({
							associated_column: "status_id",
							predicate: "=",
							values: [
								{
									id_value: values.request_state
								}
							]
						})
					}

					if (isNotEmpty(values.device)) {
						req.filters.push({
							associated_column: "device_id",
							predicate: "=",
							values: [
								{
									id_value: values.device
								}
							]
						})
					}

					if (isNotEmpty(values.round_id)) {
						req.filters.push({
							associated_column: "round_id",
							predicate: "=",
							values: [
								{
									id_value: values.round_id
								}
							]
						})
					}

					api
						.getWaitingList(req, recaptchaToken)
						.call()
						.then((res) => {
							if (isSafe(res) && isSafe(res.rows)) {
								this.data = res.rows
							} else {
								this.data = []
							}

							GlobalStore.loading(false)
						})
				})
			})
		} catch (err) {
			logger(err)
		}
	}

	@action getFilterDevices() {
		const req = {light: true}

		api
			.loadDevicePublic(req)
			.call()
			.then((devices) => {
				this.filterDevices = devices || []
			})
	}

	@action loadRounds() {
		GlobalStore.loading(true, "Načítam...")

		try {
			load(config.SITE_KEY).then((recaptcha) => {
				recaptcha.execute("records_rounds").then((recaptchaToken) => {
					api
						.getRecordRounds(recaptchaToken)
						.call()
						.then((res) => {
							if (isSafe(res) && isSafe(res.rows)) {
								this.recordRounds = res.rows.map((round) => ({
									_id: round.round_id,
									code_ext: round.round_id,
									name_ext: `${round.region_type_code_ext} + ${round.devide_group_name_ext} ${moment(
										round.start
									).format("DD.MM.YYYY")} - ${moment(round.validity_to).format("DD.MM.YYYY")}`
								}))
							} else {
								this.recordRounds = []
							}

							GlobalStore.loading(false)
						})
				})
			})
		} catch (err) {
			logger(err)
		}
	}
}

var singleton = new RequestStore()
export default singleton

